// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Button from '../core/button';
import Error from '../core/error';
import FormConfirm from '../core/form-confirm';
import Loading from '../core/loading';
import Permissions from '../core/permissions';
import RoleForm from './role-form';

// Containers
import withForm from '../../containers/with-form';
import Deletable from '../../containers/deletable';

// Styles
import './edit-role.scss';

const formName = 'editRole';

function EditRole({resetForm, formData: {values: formValues = {}} = {}, searchFetching, searchValues: {name, roleId}}) {
  const getFormProps = () => ({
    className: 'edit-role',
    formName,
    name,
    onReset: (submitted, resetValues) => resetForm(submitted, resetValues, true),
    roleId,
  });

  const getDeletableProps = () => ({
    recordId: roleId,
    formName: 'deleteRole',
  });

  const getFormConfirmProps = ({
    deleteCompleted,
    handleConfirmClick,
    handleResetClick,
    resetDelete,
    status: { error, fetching, response },
  }) => ({
    completed: deleteCompleted,
    confirmMessage: 'Are you sure you want to delete this role?',
    confirmLabel: 'Delete',
    error,
    fetching,
    formSubmitReset: resetDelete,
    onComplete: handleResetClick,
    onCancel: resetDelete,
    onConfirm: handleConfirmClick,
    response,
    searchData: formValues,
    whitelistKeys: ['roleId', 'name'],
  });

  const isDeletable = () => name !== 'admin';

  // eslint-disable-next-line react/prop-types
  const renderDeleteButton = ({ handleDeleteClick, status: { fetching }, shouldRenderDeleteButton }) => (!fetching && isDeletable() && shouldRenderDeleteButton() ? (
            <div className="edit-role--buttons">
                <Button className="edit-role--button" onClick={handleDeleteClick}>
                    Delete
                </Button>
            </div>
        ) : null);

  return (
        <Permissions adminOnly={true} notAuthorizedMessage={true}>
            {roleId ? (
                <Deletable {...getDeletableProps()}>
                    {(deletable) => (
                        <div className="edit-role">
                            {renderDeleteButton(deletable)}
                            {deletable.shouldRenderConfirm() ? (
                                <FormConfirm {...getFormConfirmProps(deletable)} />
                            ) : (
                                <RoleForm {...getFormProps()} />
                            )}
                            <Loading loading={deletable.status.fetching} />
                        </div>
                    )}
                </Deletable>
            ) : (
                <Error className="edit-role--message" error="Select a role from the list." />
            )}
            <Loading loading={searchFetching} />
        </Permissions>
  );
}

EditRole.propTypes = {
    formData: PropTypes.object.isRequired,
    resetForm: PropTypes.func,
    searchFetching: PropTypes.bool,
    searchValues: PropTypes.object,
};

export default withForm(EditRole, formName);
